import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from "semantic-ui-react/dist/es/modules/Sidebar/Sidebar.js";
import { getPropOnCondition } from "../../../utils/get-prop-on-condition";
import { Icon, ICON_NAMES } from "../../elements/Icon";
export var Component = function Component(_ref) {
  var children = _ref.children,
      hasCloseIcon = _ref.hasCloseIcon,
      isVisible = _ref.isVisible,
      onClickCloseIcon = _ref.onClickCloseIcon,
      renderSidebarContent = _ref.renderSidebarContent,
      willSlideFromTop = _ref.willSlideFromTop;
  return React.createElement(Sidebar.Pushable, null, React.createElement(Sidebar, {
    animation: "overlay",
    direction: getPropOnCondition('top', willSlideFromTop),
    visible: isVisible
  }, hasCloseIcon && React.createElement(Icon, {
    name: ICON_NAMES.CLOSE,
    onClick: onClickCloseIcon
  }), renderSidebarContent()), React.createElement(Sidebar.Pusher, {
    dimmed: isVisible
  }, children));
};
Component.displayName = 'Sidebar';
Component.defaultProps = {
  children: undefined,
  hasCloseIcon: false,
  isVisible: false,
  onClickCloseIcon: Function.prototype,
  renderSidebarContent: Function.prototype,
  willSlideFromTop: false
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  hasCloseIcon: PropTypes.bool,
  isVisible: PropTypes.bool,
  onClickCloseIcon: PropTypes.func,
  renderSidebarContent: PropTypes.func,
  willSlideFromTop: PropTypes.bool
} : {};